module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList,
      "isLimit": false
    }
  }, [_c('div', {
    slot: "import-config"
  }, [_c('el-form-item', {
    attrs: {
      "label": "自动传GET参数"
    }
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_query),
      expression: "form.is_query"
    }],
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    domProps: {
      "value": (_vm.form.is_query)
    },
    on: {
      "input": function($event) {
        _vm.form.is_query = $event
      }
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_query),
      expression: "form.is_query"
    }],
    staticClass: "radio",
    attrs: {
      "label": 0
    },
    domProps: {
      "value": (_vm.form.is_query)
    },
    on: {
      "input": function($event) {
        _vm.form.is_query = $event
      }
    }
  }, [_vm._v("关闭")])]), _vm._v(" "), _c('div', {
    staticClass: "block p-20 pos-rel",
    staticStyle: {
      "width": "570px"
    }
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("基础配置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作表名",
      "prop": "sheet_name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.sheet_name),
      expression: "form.sheet_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.sheet_name)
    },
    on: {
      "input": function($event) {
        _vm.form.sheet_name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起始导入行数",
      "prop": "first_import"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.first_import),
      expression: "form.first_import",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.first_import)
    },
    on: {
      "input": function($event) {
        _vm.form.first_import = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "导入文件大小限制（单位MB，0为不限制）",
      "prop": "limit_size"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.limit_size),
      expression: "form.limit_size",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.limit_size)
    },
    on: {
      "input": function($event) {
        _vm.form.limit_size = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "导入模版上传（不上传则不显示模版下载）"
    }
  }, [_c('el-upload', {
    ref: "fileupload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.fileUrl,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.successCb,
      "on-remove": _vm.removeCb,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.upload_name))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v("只支持xlsx上传文件")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileList.length > 0),
      expression: "fileList.length>0"
    }],
    staticClass: "downloadBtn",
    attrs: {
      "href": _vm.form.template_url
    }
  }, [_vm._v("下载模版")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表头校验（校验表头内容，以避免导入错误模版，可不填）"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "561px"
    },
    attrs: {
      "data": _vm.form.title_config,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "列（数字列标号）",
      "width": "150"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model.trim",
            value: (scope.row.col),
            expression: "scope.row.col",
            modifiers: {
              "trim": true
            }
          }],
          staticClass: "h-40",
          attrs: {
            "placeholder": "请输入大写字母"
          },
          domProps: {
            "value": (scope.row.col)
          },
          on: {
            "input": function($event) {
              scope.row.col = (typeof $event === 'string' ? $event.trim() : $event)
            },
            "blur": function($event) {
              _vm.$forceUpdate()
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "行数（数字行标号）",
      "width": "170"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model.trim",
            value: (scope.row.row),
            expression: "scope.row.row",
            modifiers: {
              "trim": true
            }
          }],
          staticClass: "h-40",
          attrs: {
            "placeholder": "请输入"
          },
          domProps: {
            "value": (scope.row.row)
          },
          on: {
            "input": function($event) {
              scope.row.row = (typeof $event === 'string' ? $event.trim() : $event)
            },
            "blur": function($event) {
              _vm.$forceUpdate()
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内容",
      "width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model.trim",
            value: (scope.row.content),
            expression: "scope.row.content",
            modifiers: {
              "trim": true
            }
          }],
          staticClass: "h-40",
          attrs: {
            "placeholder": "请输入"
          },
          domProps: {
            "value": (scope.row.content)
          },
          on: {
            "input": function($event) {
              scope.row.content = (typeof $event === 'string' ? $event.trim() : $event)
            },
            "blur": function($event) {
              _vm.$forceUpdate()
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteTitleConfig(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 m-b-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTitleConfig
    }
  }, [_vm._v("添加")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block p-20 pos-rel m-t-30",
    staticStyle: {
      "width": "935px"
    }
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("数据配置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getAllfields
    }
  }, [_vm._v("获取所有字段")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "931px"
    },
    attrs: {
      "data": _vm.form.import_fields,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "选择字段",
      "width": "160"
    },
    scopedSlots: {
      default: function(scope) {
        return [(_vm.formFieldsLabels[scope.row.field_id]) ? _c('dropdown-input', {
          attrs: {
            "inputSource": _vm.selectFormFields,
            "value": _vm.formFieldsLabels[scope.row.field_id]['value'],
            "placeholder": _vm.请输入内容,
            "listIndex": scope.$index
          },
          on: {
            "handleSelectField": _vm.handleSelectField
          }
        }) : _c('dropdown-input', {
          attrs: {
            "inputSource": _vm.selectFormFields,
            "value": _vm.nullVal,
            "placeholder": _vm.请输入内容,
            "listIndex": scope.$index
          },
          on: {
            "handleSelectField": _vm.handleSelectField
          }
        }), _vm._v(" ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "字段类型及配置",
      "width": "170"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.type))]), _vm._v(" "), (_vm.isStruct(scope.row.fieldtype_id) || _vm.isForeign(scope.row.fieldtype_id) || _vm.isUser(scope.row.fieldtype_id)) ? _c('el-button', {
          staticClass: "config",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.configOperation(scope.row, scope.$index)
            }
          }
        }, [_vm._v("\n                  配置\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isKey(scope.row.fieldtype_id) && scope.row.has_config) ? _c('el-button', {
          staticClass: "config",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.configOperation(scope.row, scope.$index)
            }
          }
        }, [_vm._v("\n                  配置\n                ")]) : _vm._e()]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "对应导入列 (多列考虑用;号分隔开，合并列用&连接)",
      "width": "260"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model.trim",
            value: (scope.row.col),
            expression: "scope.row.col",
            modifiers: {
              "trim": true
            }
          }],
          staticClass: "h-40",
          attrs: {
            "placeholder": "请输入"
          },
          domProps: {
            "value": (scope.row.col)
          },
          on: {
            "input": function($event) {
              scope.row.col = (typeof $event === 'string' ? $event.trim() : $event)
            },
            "blur": function($event) {
              _vm.$forceUpdate()
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数据清洗",
      "width": "260"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._l((scope.row.deal_type), function(tag, tindex) {
          return _c('el-tag', {
            attrs: {
              "type": "danger"
            }
          }, [_vm._v(_vm._s(_vm.tempDealTypes[tag]["name"]))])
        }), _vm._v(" "), _c('el-button', {
          staticClass: "m-l-10",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.selectCleanType(scope.$index)
            }
          }
        }, [_vm._v("选择")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteImportConfig(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 m-b-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addImportConfigObj
    }
  }, [_vm._v("添加")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block p-20 pos-rel m-t-30",
    staticStyle: {
      "width": "560px"
    }
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("数据已存在校验配置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启数据已存在校验"
    }
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_unique),
      expression: "form.is_unique"
    }],
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    domProps: {
      "value": (_vm.form.is_unique)
    },
    on: {
      "input": function($event) {
        _vm.form.is_unique = $event
      }
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_unique),
      expression: "form.is_unique"
    }],
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    domProps: {
      "value": (_vm.form.is_unique)
    },
    on: {
      "input": function($event) {
        _vm.form.is_unique = $event
      }
    }
  }, [_vm._v("否")])]), _vm._v(" "), (_vm.form.is_unique == "1") ? _c('el-form-item', {
    attrs: {
      "label": "是否开启数据已存在校验"
    }
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.check_type),
      expression: "form.check_type"
    }],
    staticClass: "radio",
    attrs: {
      "label": "10"
    },
    domProps: {
      "value": (_vm.form.check_type)
    },
    on: {
      "input": function($event) {
        _vm.form.check_type = $event
      }
    }
  }, [_vm._v("AND（需多个字段同时存在）")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.check_type),
      expression: "form.check_type"
    }],
    staticClass: "radio",
    attrs: {
      "label": "20"
    },
    domProps: {
      "value": (_vm.form.check_type)
    },
    on: {
      "input": function($event) {
        _vm.form.check_type = $event
      }
    }
  }, [_vm._v("OR（按优先度判断）")])]) : _vm._e(), _vm._v(" "), (_vm.form.is_unique == "1") ? _c('el-form-item', {
    attrs: {
      "label": "校验字段"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form.unique_config,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "优先度",
      "width": "120"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.$index != 0) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.moveTr(scope.$index, 0)
            }
          }
        }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (scope.$index != _vm.form.unique_config.length - 1) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.moveTr(scope.$index, 1)
            }
          }
        }, [_vm._v("下移")]) : _vm._e()]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "选择字段"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.field_id),
            expression: "scope.row.field_id"
          }],
          attrs: {
            "filterable": "",
            "size": "small"
          },
          domProps: {
            "value": (scope.row.field_id)
          },
          on: {
            "input": function($event) {
              scope.row.field_id = $event
            }
          }
        }, _vm._l((_vm.formFields), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.default.title,
              "value": item.default.field_id
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "70"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteUnique(scope.row, scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.addUnique()
      }
    }
  }, [_vm._v("添加")])])]) : _vm._e(), _vm._v(" "), (_vm.form.is_unique == "1") ? _c('el-form-item', {
    attrs: {
      "label": "数据已存在的处理方式"
    }
  }, _vm._l((_vm.uniqueTypes), function(type) {
    return _c('el-radio', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.unique_type),
        expression: "form.unique_type"
      }],
      staticClass: "radio uniqueRadio",
      attrs: {
        "label": type.id
      },
      domProps: {
        "value": (_vm.form.unique_type)
      },
      on: {
        "input": function($event) {
          _vm.form.unique_type = $event
        }
      }
    }, [_vm._v("\n          " + _vm._s(type.name) + "\n          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.uniqueFieldShow) ? _c('el-form-item', {
    attrs: {
      "label": "请选择选中字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.unique_over_fields),
      expression: "form.unique_over_fields"
    }],
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择字段"
    },
    domProps: {
      "value": (_vm.form.unique_over_fields)
    },
    on: {
      "input": function($event) {
        _vm.form.unique_over_fields = $event
      }
    }
  }, _vm._l((_vm.formFields), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.default.title,
        "value": item.default.field_id
      }
    })
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block p-20 pos-rel m-t-30",
    staticStyle: {
      "width": "560px"
    }
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("导入记录配置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启导入记录"
    }
  }, [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_report),
      expression: "form.is_report"
    }],
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    domProps: {
      "value": (_vm.form.is_report)
    },
    on: {
      "input": function($event) {
        _vm.form.is_report = $event
      }
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_report),
      expression: "form.is_report"
    }],
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    domProps: {
      "value": (_vm.form.is_report)
    },
    on: {
      "input": function($event) {
        _vm.form.is_report = $event
      }
    }
  }, [_vm._v("否")])]), _vm._v(" "), (_vm.form.is_report == "1") ? _c('el-form-item', {
    attrs: {
      "label": "记录内容"
    }
  }, [_c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.isAll),
      expression: "form.isAll"
    }],
    domProps: {
      "value": (_vm.form.isAll)
    },
    on: {
      "change": _vm.isAllSelect,
      "input": function($event) {
        _vm.form.isAll = $event
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.report_type),
      expression: "form.report_type"
    }],
    domProps: {
      "value": (_vm.form.report_type)
    },
    on: {
      "change": _vm.handleReportTypeChange,
      "input": function($event) {
        _vm.form.report_type = $event
      }
    }
  }, _vm._l((_vm.contentTypes), function(type) {
    return _c('el-checkbox', {
      key: type.id,
      attrs: {
        "label": type.id
      }
    }, [_vm._v("\n            " + _vm._s(type.name) + "\n            ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.fieldShow && _vm.form.is_report == "1") ? _c('el-form-item', {
    attrs: {
      "label": "请选择导入数据的字段"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.report_fields),
      expression: "form.report_fields"
    }],
    attrs: {
      "multiple": "",
      "placeholder": "请选择字段"
    },
    domProps: {
      "value": (_vm.form.report_fields)
    },
    on: {
      "input": function($event) {
        _vm.form.report_fields = $event
      }
    }
  }, _vm._l((_vm.formFields), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.default.title,
        "value": item.default.field_id
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.form.is_report == "1") ? _c('el-form-item', {
    attrs: {
      "label": "查看记录的权限规则绑定"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.report_ruleName),
      expression: "form.report_ruleName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 fl w-200",
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": (_vm.form.report_ruleName)
    },
    on: {
      "input": function($event) {
        _vm.form.report_ruleName = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.form.report_ruleName == "") ? _c('el-button', {
    staticClass: "fl m-l-30",
    on: {
      "click": function($event) {
        _vm.openRule()
      }
    }
  }, [_vm._v("查找")]) : _c('el-button', {
    staticClass: "fl m-l-10",
    on: {
      "click": function($event) {
        _vm.clearRule()
      }
    }
  }, [_vm._v("清空")]), _vm._v(" ")]) : _vm._e()])])]), _vm._v(" "), _c('rule-list', {
    ref: "ruleList",
    on: {
      "selectRule": _vm.selectRule
    }
  }), _vm._v(" "), _c('cleantype-dialog', {
    ref: "cleantype",
    attrs: {
      "dealTypesSource": _vm.dealTypes,
      "curDealType": _vm.curDealType,
      "curfieldsIndex": _vm.curfieldsIndex
    },
    on: {
      "setCleanType": _vm.setCleanType
    }
  }), _vm._v(" "), _c('config-operation', {
    ref: "configOperation",
    attrs: {
      "curConfigData": _vm.curConfigData
    },
    on: {
      "confirmConfigOperation": _vm.confirmConfigOperation
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e0ea7d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/importConfig.vue
// module id = 1879
// module chunks = 2